/* eslint-disable react-hooks/exhaustive-deps */
import { Box, IconButton, List, MenuItem, Stack, Typography, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import Input from '../ui/forms/fields/input';

import TeamColorPicker from '../ui/teamControls/teamColorPicker';
import { useFormContext } from 'react-hook-form';
import { Fragment, useEffect, useState } from 'react';
import gameFormatService from '../../features/gameFormat/gameFormatService';
import { Delete } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import PlayerNames from '../ui/playerDisplay/playerNames';

const CustomMultipleVs = ({ gameType }) => {
  const theme = useTheme();
  const [teamA, setTeamA] = useState({ players: [], color: 'green' });
  const [teamB, setTeamB] = useState({ players: [], color: 'red' });
  const [teams, setTeams] = useState({});
  const [teamLimit, setTeamLimit] = useState(0);

  const [playerA, setPlayerA] = useState('');
  const [playerB, setPlayerB] = useState('');

  const isMobile = theme.breakpoints.down('sm') ? true : false;

  //Register teamA and teamB
  const {
    register,
    setValue,
    watch,
    formState: { errors }
  } = useFormContext();

  //REgister teamA field and teamB field
  useEffect(() => {
    register('teams');
  }, [register]);

  useEffect(() => {
    setTeamLimit(gameFormatService.getGameTypeLimit(gameType) / 2);
    setTeamA({ players: [], color: 'green' });
    setTeamB({ players: [], color: 'red' });
  }, [gameType]);

  useEffect(() => {
    setTeams({ teamA, teamB });
  }, [teamA, teamB]);

  useEffect(() => {
    setValue('teams', teams);
  }, [teams, setValue]);

  const watchTeamAColor = watch('teamAColor');
  const watchTeamBColor = watch('teamBColor');

  useEffect(() => {
    setTeamA({ ...teamA, color: watchTeamAColor });
  }, [watchTeamAColor]);

  useEffect(() => {
    setTeamB({ ...teamB, color: watchTeamBColor });
  }, [watchTeamBColor]);

  const addPlayerOnEnter = (event, team) => {
    if (event.target.value === '') return;
    if (event.key !== 'Enter') return;
    const player = event.target.value;
    if (team === 'A') {
      if (teamA.players.length >= teamLimit) return;
      setTeamA({ ...teamA, players: [...teamA.players, player] });
      setPlayerA('');
    } else {
      if (teamB.players.length >= teamLimit) return;
      setTeamB({ ...teamB, players: [...teamB.players, player] });
      setPlayerB('');
    }

    event.target.value = '';
  };

  const addPlayer = (team) => {
    if (team === 'A') {
      if (playerA === '') return;
      if (teamA.players.length >= teamLimit) return;
      setTeamA({ ...teamA, players: [...teamA.players, playerA] });
      setPlayerA('');
    } else {
      if (playerB === '') return;
      if (teamB.players.length >= teamLimit) return;
      setTeamB({ ...teamB, players: [...teamB.players, playerB] });
      setPlayerB('');
    }
  };

  const removePlayer = (player, team) => {
    if (team === 'A') {
      const newPlayersA = teamA.players.filter((p) => p !== player);
      setTeamA({ ...teamA, players: newPlayersA });
    } else {
      const newPlayersB = teamB.players.filter((p) => p !== player);
      setTeamB({ ...teamB, players: newPlayersB });
    }
  };

  return (
    <Fragment>
      <Typography variant="h6" color="primary" sx={{ mt: 2 }}>
        Players Select
      </Typography>
      <Box
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        justifyContent={'space-evenly'}
        gap={1}>
        <Box display="flex" flexDirection={'column'} maxWidth={'450px'} mx={1}>
          <Typography>Team A</Typography>
          <Box display="flex" flexDirection={'row'} gap={1}>
            <Input
              name={'playerA'}
              label="Player Name"
              value={playerA}
              onKeyUp={(event) => addPlayerOnEnter(event, 'A')}
              onChange={(event) => setPlayerA(event.target.value)}
            />
            <IconButton
              onClick={() => addPlayer('A')}
              color={'primary'}
              sx={{ height: '56px', p: 0 }}>
              <AddIcon />
            </IconButton>
            <Box sx={{ alignSelf: 'flex-start' }}>
              <TeamColorPicker name={'teamAColor'} defaultValue={'green'} />
            </Box>
          </Box>
          <List>
            {teamA.players.map((player, index) => (
              <MenuItem key={index} value={player}>
                <Stack direction="row" gap={1} alignItems={'center'}>
                  {player}
                  <IconButton size="small" onClick={() => removePlayer(player, 'A')}>
                    <Delete color="error" />
                  </IconButton>
                </Stack>
              </MenuItem>
            ))}
          </List>
        </Box>
        {!isMobile && (
          <Typography
            variant="h6"
            color="primary"
            fontWeight="bold"
            sx={{ mx: 2, alignSelf: 'center' }}>
            VS
          </Typography>
        )}
        <Box m={2} />

        <Box display="flex" flexDirection={'column'} maxWidth={'450px'} mx={1}>
          <Typography>Team B</Typography>
          <Box display="flex" flexDirection={'row'} gap={1}>
            <Input
              name={'playerB'}
              label="Player Name"
              value={playerB}
              onKeyUp={(event) => addPlayerOnEnter(event, 'B')}
              onChange={(event) => setPlayerB(event.target.value)}
            />
            <IconButton
              onClick={() => addPlayer('B')}
              color={'primary'}
              sx={{ height: '56px', p: 0 }}>
              <AddIcon />
            </IconButton>
            <Box sx={{ alignSelf: 'flex-start' }}>
              <TeamColorPicker name={'teamBColor'} defaultValue={'red'} />
            </Box>
          </Box>
          <List>
            {teamB.players.map((player, index) => (
              <MenuItem key={index} value={player}>
                <Stack direction="row" gap={1} alignItems={'center'}>
                  {player}
                  <IconButton size="small" onClick={() => removePlayer(player, 'B')}>
                    <Delete color="error" />
                  </IconButton>
                </Stack>
              </MenuItem>
            ))}
          </List>
        </Box>
      </Box>
    </Fragment>
  );
};

export default CustomMultipleVs;
